import { useState } from 'react';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Card, Collapse, List, ListItem, ListItemButton, ListItemText, ListSubheader, Typography, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useIntl } from 'react-intl';
import { ResumenProducts } from 'types/components/shared';

const CardRatings = ({ resume, sumaValores, setTypeScore }: { resume: ResumenProducts; sumaValores: any; setTypeScore: any }) => {
    const intl = useIntl();
    const [open, setOpen] = useState<boolean>(false);
    const handleClick = () => {
        setOpen(!open);
    };
    const handleClickDetail = (type: string) => {
        setTypeScore(type);
    };

    const theme = useTheme();
    return (
        <>
            <Card>
                <List
                    sx={{
                        width: '100%',
                        borderRadius: '10px',
                        background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.grey[50],
                        border: '1px solid',
                        borderColor: theme.palette.mode === 'dark' ? 'transparent' : theme.palette.grey[100],
                        '&:hover': {
                            border: `1px solid${theme.palette.primary.main}`
                        }
                    }}
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                    subheader={
                        <ListSubheader
                            component="div"
                            id="nested-list-subheader"
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                pt: 1,
                                pb: 1,
                                bgcolor: 'transparent'
                            }}
                        >
                            <Typography variant="h3">{intl.formatMessage({ id: `${resume?.description}` })}</Typography>
                            <Typography variant="h3">{`${resume?.totalProductsPercentage?.toFixed(2)}%`}</Typography>
                        </ListSubheader>
                    }
                >
                    <ListItemButton onClick={handleClick} sx={{ display: 'flex', justifyContent: 'center' }}>
                        {open ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <ListItem sx={{ display: 'flex', justifyContent: 'center' }}>
                        <ListItemText
                            primary={`${intl.formatMessage({ id: 'Products' })}: ${intl.formatNumber(
                                resume.totalProducts ?? 0
                            )}/${intl.formatNumber(sumaValores())}`}
                        />
                        <Button
                            onClick={() => handleClickDetail(resume?.description)}
                            variant="outlined"
                            size="small" // eslint-disable-next-line no-nested-ternary
                            color={resume?.description === 'Good' ? 'success' : resume?.description === 'Fair' ? 'warning' : 'error'}
                        >
                            {intl.formatMessage({ id: 'details' })}
                        </Button>
                    </ListItem>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <ListItem>
                            <ListItemText primary={intl.formatMessage({ id: 'Total_Products_Score' })} />
                            {`${resume.totalProductScore?.toFixed(2)}%`}
                        </ListItem>
                        <ListItem>
                            <ListItemText primary={intl.formatMessage({ id: 'Total_Sku_Score' })} />
                            {`${resume.totalSkuScore?.toFixed(2)}%`}
                        </ListItem>
                        <ListItem>
                            <ListItemText primary={intl.formatMessage({ id: 'Total_Score' })} />
                            {`${resume.totalScore?.toFixed(2)}%`}
                        </ListItem>
                    </Collapse>
                </List>
            </Card>
        </>
    );
};

export default CardRatings;
